import * as React from 'react';

export const Keys = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  ENTER: 'Enter',
};

export const SPLASH = '/';
export const EVERY_CHARACTERS_UNTIL_SPLASH_REGEX = /.*(?=\/)/g;
export const EVERY_CHARACTERS_SINCE_SPACE = /\s.*/g;
export const EMPTY_STRING = '';

export interface CommandProps extends React.HTMLAttributes<HTMLButtonElement> {
  /**
   * for command tool fuzzy search
   */
  label: string;
  /**
   * same. E.g: 'b'
   */
  hotkey: string;
  description?: string;
  icon?: React.ReactNode;
}
